import { CommonPagination } from "@/types/common";

export const DEFAULT_PAGINATION: CommonPagination = {
  page: 0,
  limit: 500,
};
